<div class="each">
  <a routerLink="/products/{{data.catalog_alias}}/{{data.collection_alias}}/{{data.id}}/{{data.title_alias}}">
    <div class="pd-thumb">
      <ion-skeleton-text style="width: auto;
      position: absolute;
      aspect-ratio: 1/1;" [animated]="true" *ngIf="!data?.file?.loaded" ></ion-skeleton-text>
      <img (load)="data.file.loaded=true" [class.animate__fadeIn]="data?.file?.loaded" [class.opacity-0]="!data?.file?.loaded" src="{{data?.file?.thumb_url}}" class="animate__animated animate__faster" alt="{{data?.catalog}}">
    </div>
    <div class="cat-rate">
      <b>
        <svg xmlns="http://www.w3.org/2000/svg" width="14.551" height="16.001" viewBox="0 0 14.551 16.001">
          <g id="directbox-default" transform="translate(-2.25 -1.25)">
            <path id="Path_35" data-name="Path 35"
                  d="M5.9,12C3,12,3,13.3,3,14.9v.725c0,2,0,3.625,3.625,3.625h5.8c2.9,0,3.625-1.624,3.625-3.625V14.9c0-1.6,0-2.9-2.9-2.9a1.712,1.712,0,0,0-1.305.435l-.74.783a2.174,2.174,0,0,1-3.169,0l-.732-.783A1.712,1.712,0,0,0,5.9,12Z"
                  transform="translate(0 -2.749)" fill="none" stroke="#666" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5"/>
            <path id="Path_36" data-name="Path 36" d="M15.151,9.251V4.9c0-1.6,0-2.9-2.9-2.9H7.9C5,2,5,3.3,5,4.9v4.35" transform="translate(-0.55)" fill="none" stroke="#666" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"
                  stroke-width="1.5" opacity="0.4"/>
          </g>
        </svg>
        {{data.catalog}}</b>
      <!-- <div class="rating">
        <img src="../../../assets/img/rate.png" alt="rating"/>
      </div> -->
    </div>
    <h4>{{data.title}}</h4>
  </a>
</div>
